import { generateAnalyticSummaryPageData } from "HelperFiles/DataGenerator";
import { setAnalyticSummaryPageData } from "./DashboardVariables";

// action
export const setSelectedIncidents = (data) => ({ type: 'SELECTED_INCIDENTS', payload: data });
export const setSelectedIncidentsMidlleware =
  ({ dispatch, getState }) =>
    (next) =>
      (action) => {
        next(action);
        if (action.type == 'SELECTED_INCIDENTS') {
          const analyticSummaryPageData = generateAnalyticSummaryPageData({
            wholeData: getState().wholeData,
            locationSelected: getState().locationSelected,
            cameraSelected: getState().cameraSelected,
            cameraData: getState().cameraData,
            locationsData: getState().locationsData,
            searchStartDate: getState().searchStartDate,
            searchEndDate: getState().searchEndDate,
            allIncidents: getState().allIncidents,
            selectedIncidents: action.payload,
            applicationConfig: getState().applicationConfig
          });

          dispatch(setAnalyticSummaryPageData(analyticSummaryPageData));
        }
      }
// Reducers
export const setSelectedIncidentsReducer = (state = [], action = { type: '', payload: [] }) => {
  if (action.type === 'SELECTED_INCIDENTS') { return action.payload; } else { return state; }
};
// Selectors
export const getSelectedIncidents = (state) => state.selectedIncidents;


